import * as stylex from '@stylexjs/stylex';
import Image from 'next/image';
import { RichText } from './RichText';
import { PageSectionsContentSectionContentBlocksStaffBioList, PageSectionsContentSectionContentBlocksStaffBioListStaffBioReference } from '@/tina/__generated__/types';
import { MeetingButton } from './HubspotMeetingLink/MeetingButton';
import { layout } from '../styles/layout';
import '../styles/tokens.stylex';
import { spacing } from '../styles/tokens.stylex';
import { typography } from '../styles/typography';
import { tinaField } from 'tinacms/dist/react';
interface StaffBioCardsListProps {
  data: PageSectionsContentSectionContentBlocksStaffBioList;
}
interface StaffBioCardProps {
  data: PageSectionsContentSectionContentBlocksStaffBioListStaffBioReference | null;
}
export function StaffBioCardsList({
  data
}: StaffBioCardsListProps) {
  return data ? <ul className="xe8uvvx x1717udv x1ghz6dp xrvj5dj x1mhrlx8 x15u4aoh xhnfb2g">
      {data.staffBioReference?.map((bio, i) => {
      return <StaffBioCard key={`${i}-${bio?.reference?._sys.filename}`} data={bio} />;
    })}
    </ul> : null;
}
export function StaffBioCard({
  data,
  ...props
}: StaffBioCardProps) {
  const firstName = data?.reference?.staffName.split(/ /g)[0];
  return data ? <li {...stylex.props(layout.contentCard, sx.bioCard)} {...props}>
      <article className="xrvj5dj x1pte3vf xxhr3t x1clt5hq x1717udv">
        <div className="x1o4oh2x xrvj5dj x3ybb33 x1c4oqta x1clt5hq">
          <div className="xrvj5dj x1clt5hq x3ybb33 xjej8gk">
            <div>
              <h1 {...stylex.props(typography.heading2)} data-tina-field={tinaField(data, 'reference')}>
                {data.reference?.staffName}
              </h1>
              <p {...stylex.props(typography.small)}>
                {data.reference?.staffRole}
              </p>
            </div>
            <RichText>{data.reference?.staffBio}</RichText>
          </div>
          {data.includeMeetingLink && <MeetingButton meetingLink={data.includeMeetingLink.meetingLink} buttonProps={{
          iconLeft: 'calendar-check',
          centerTextBlock: true
        }}>
              {`Book a meeting${firstName ? ' with ' + firstName : ''}`}
            </MeetingButton>}
        </div>
        {data?.reference?.image && <div className="x1n2onr6 x1dltgaz xs1mv8g xgqtt45 x1clqncf">
            <Image src={data.reference?.image} alt={data.reference?.alt} fill className="xl1xv1r" sizes="100%, (min-width: 800px) 540px" />
          </div>}
      </article>
    </li> : null;
}
const sx = {
  bioCard: {
    k1xSpc: "xrvj5dj",
    kbNqZ1: "x1pte3vf",
    kOIVth: "xxhr3t",
    k9llMU: "x1clt5hq",
    kmVPX3: "x1717udv",
    $$css: true
  }
};